import React, { useRef, useState } from "react";
import referBanner from "../../assets/images/refer-a-friend-graphic.svg";
import icons from "../../assets/images/sprite-other-icons.svg";

const ReferAFriend = () => {
    const referCodetxt = useRef(null);
    const [referSuccessMsg, setReferSuccessMsg] = useState(false);

    const handleCopyClick = () => {
        if (referCodetxt.current) {
            referCodetxt.current.select();
            document.execCommand('copy');
            setReferSuccessMsg(true);

            setTimeout(() => setReferSuccessMsg(false), 2000);
        }
    };

    return (
        <div className="SB-myAccountSection-container SB-referAFriend">
            <div className="SB-pageHeader">
                <div className="SB-pageHeader-title">Refer A Friend</div>
            </div>
            <div className="SB-referAFriend-container">
                <div className="SB-referAFriend-content">
                    <h2 className="SB-referAFriend-heading">Invite &amp; Earn</h2>
                    <div className="SB-referAFriend-description">Copy your code, share it with your friends.</div>

                    <div className="SB-referAFriend-code-container">
                        <div className="SB-label">Your Referral Code</div>
                        <div className="SB-form-group">
                            <div className="SB-form-control-group SB-referAFriendCode">
                                <div className="SB-form-control">
                                    <input type="text" readonly="" value="PIXR01" ref={referCodetxt} />
                                </div>
                                <div className="SB-form-addon SB-addon-right" role="none" onClick={handleCopyClick}>Copy</div>
                                {/* <!-- <div className="SB-form-addon SB-addon-right" role="none">copied</div> --> */}
                            </div>
                            <div className="SB-form-errorMsg"><span id=""></span></div>
                        </div>
                    </div>
                    {
                        referSuccessMsg ?
                            <div className="SB-successMsg">
                                <span>Referral Code copied successfully</span>
                            </div>
                            :
                            ""
                    }
                    <div className="SB-divider">OR</div>
                    <div className="SB-socialShareButtons">
                        <ul>
                            <li>
                                <button type="button" aria-label="Share on Facebook">
                                    <div className="SB-iconSVG">
                                        <svg xmlns="http://www.w3.org/2000/svg">
                                            <use xlinkHref={`${icons}#${"icon-facebook"}`}></use>
                                        </svg>
                                    </div>
                                </button>
                            </li>
                            <li>
                                <button type="button" aria-label="Share on Instagram">
                                    <div className="SB-iconSVG">
                                        <svg xmlns="http://www.w3.org/2000/svg">
                                            <use xlinkHref={`${icons}#${"icon-instagram"}`}></use>
                                        </svg>
                                    </div>
                                </button>
                            </li>
                            <li>
                                <button type="button" aria-label="Share on Twitter">
                                    <div className="SB-iconSVG">
                                        <svg xmlns="http://www.w3.org/2000/svg">
                                            <use xlinkHref={`${icons}#${"icon-twitter"}`}></use>
                                        </svg>
                                    </div>
                                </button>
                            </li>
                            <li>
                                <button type="button" aria-label="Share on Telegram">
                                    <div className="SB-iconSVG">
                                        <svg xmlns="http://www.w3.org/2000/svg">
                                            <use xlinkHref={`${icons}#${"icon-telegram"}`}></use>
                                        </svg>
                                    </div>
                                </button>
                            </li>
                            <li>
                                <button type="button" aria-label="Share on LinkedIn">
                                    <div className="SB-iconSVG">
                                        <svg xmlns="http://www.w3.org/2000/svg">
                                            <use xlinkHref={`${icons}#${"icon-linkedin"}`}></use>
                                        </svg>
                                    </div>
                                </button>
                            </li>
                            <li>
                                <button type="button" aria-label="Share on WhatsApp">
                                    <div className="SB-iconSVG">
                                        <svg xmlns="http://www.w3.org/2000/svg">
                                            <use xlinkHref={`${icons}#${"icon-whatsapp"}`}></use>
                                        </svg>
                                    </div>
                                </button>
                            </li>
                            <li>
                                <button type="button" aria-label="Copy referral link">
                                    <div className="SB-iconSVG">
                                        <svg xmlns="http://www.w3.org/2000/svg">
                                            <use xlinkHref={`${icons}#${"icon-link"}`}></use>
                                        </svg>
                                    </div>
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className="SB-successMsg">
                        <span>Referral link copied successfully</span>
                    </div>
                    <div className="SB-mobileSocialShare">
                        <button id="share-btn" className="btn SB-btnSecondary active SB-btnMedium">
                            <span className="sb-icon icon-share"></span> Share
                        </button>
                    </div>
                </div>
                <div className="SB-referAFriend-image">
                    <img src={referBanner} alt="refer-a-friend-graphic" />
                </div>
            </div>
        </div>
    )
}
export default ReferAFriend;